import { render, staticRenderFns } from "./ConfiguracoesVendaList.vue?vue&type=template&id=7d45bed3"
import script from "./ConfiguracoesVendaList.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesVendaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports